import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'container mb-8',
    tag: 'px-3.5'
  }
});
